import 'idempotent-babel-polyfill';
import emav from './emav';
export default emav;